import { Component, computed, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { ToastService } from './toast.service';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { ToastPosition } from '../../../types/toast.type';
import { SafePipe } from 'ngx-unificator/pipes';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [
    NgComponentOutlet,
    SvgIconComponent,
    SafePipe
  ],
})
export class ToastHostComponent {
  public toastService = inject(ToastService);

  positions: ToastPosition[] = [
    'top-right',
    'top-left',
    'top-center',
    'bottom-right',
    'bottom-left',
    'bottom-center'
  ];

  grouped = computed(() =>
    Object.fromEntries(
      this.positions.map(pos => [
        pos,
        this.toastService.toasts().filter(t => t.position === pos)
      ])
    )
  );
}
